import Vue from 'vue';
import Vuex from 'vuex';
import Storage from '@/support/Storage';
import { unique } from '@/support/Object';
Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        drawer: true,
        miniNav: false,
        Auth: null,
        filters: [],
        lessonTypes: [],
        openingHours: null,
        curriculum: null,
        router: {},
        period: null,
        year: null,
        tags: null,
        selected: null,
        selectedTopics: [],
        dialog: null,
        settings: [],
        isSubjectChecked: null,
        version: null,
        isOffline: false,
        isLoading: true,
        isStoreInitialized: false,
    },
    getters: {
        getSetting: (state) => (key) => {
            const setting = state.settings.find((setting) => {
                return setting.key === key;
            });
            return setting;
        },
        hasBrinNumber(state) {
            const setting = state.settings.find((setting) => {
                return setting.key === 'parnassys_brinnummer';
            });
            return !!((setting) && setting.value);
        },
    },
    mutations: {
        USER_AUTHENTICATED: (state, payload) => {
            state.Auth = payload;
        },
        USER_DEAUTHENTICATED: (state, _payload) => {
            if (state.Auth !== null && state.Auth !== undefined) {
                state.Auth.logout();
            }
            state.Auth = null;
        },
        DRAWER_TOGGLE: (state, forcedState) => {
            state.drawer = !state.drawer;
        },
        CURRICULUM_LOADED: (state, payload) => {
            state.curriculum = payload;
        },
        SETTINGS_LOADED: (state, settings) => {
            state.settings = settings;
            settings.forEach((setting) => {
                if (!setting.key) {
                    return;
                }
                Storage.set(setting.key, setting.value);
            });
        },
        OPENINGHOURS_LOADED: (state, openingHours) => {
            state.openingHours = openingHours;
        },
        LABELS_LOADED: (state, labels) => {
            state.labels = labels;
        },
        TREATMENTLABELS_LOADED: (state, treatmentLabels) => {
            state.treatment_labels = treatmentLabels;
        },
        VERSION_LOADED: (state, version) => {
            state.version = version;
        },
        PERIOD_LOADED: (state, period) => {
            state.period = period;
        },
        YEAR_LOADED: (state, year) => {
            state.year = year;
        },
        TAGS_LOADED: (state, tags) => {
            state.tags = tags;
        },
        MINI_TOGGLE: (state, forcedState) => {
            if (forcedState !== undefined) {
                state.miniNav = forcedState;
                return;
            }
            state.miniNav = !state.miniNav;
        },
        FILTERS_UPDATE: (state, payload) => {
            state.filters = { ...state.filters, ...payload };
        },
        LESSONTYPES_UPDATE: (state, payload) => {
            state.lessonTypes = { ...state.lessonTypes, ...payload };
        },
        SELECTED_CHANGE: (state, payload) => {
            payload = unique(payload, 'id');
            state.selected = payload;
        },
        SELECTED_TOPICS_CHANGE: (state, payload) => {
            payload = unique(payload, 'id');
            state.selectedTopics = payload;
        },
        DIALOG_OPENED: (state, options) => {
            state.dialog = options;
        },
        DIALOG_CLOSED: (state, options) => {
            state.dialog = null;
        },
        RESET_CHECKBOXES: (state, payload) => {
            state.isSubjectChecked = payload;
        },
        UPDATE_SETTING: (state, payload) => {
            const setting = state.settings.find((sett) => {
                return sett.key === payload.key;
            });
            if (!setting) {
                throw new Error(`Setting ${payload.key} not found`);
            }
            setting.value = payload.value;
        },
        SET_API_OFFLINE: (state, value) => {
            state.isOffline = value;
        },
        SET_IS_LOADING: (state, value) => {
            state.isLoading = value;
        },
        SET_IS_STORE_INITIALIZED: (state, value) => {
            state.isStoreInitialized = value;
        },
    },
    actions: {
        userAuthenticated: (context, payload) => {
            context.commit('USER_AUTHENTICATED', payload);
        },
        userDeauthenticated: (context, payload) => {
            context.commit('USER_DEAUTHENTICATED', payload);
        },
        toggleDrawer: (context, payload) => {
            context.commit('DRAWER_TOGGLE', payload);
        },
        loadedCurriculum: (context, payload) => {
            context.commit('CURRICULUM_LOADED', payload);
        },
        loadedSettings: (context, settings) => {
            context.commit('SETTINGS_LOADED', settings);
        },
        loadedCurrentPeriod: (context, period) => {
            context.commit('PERIOD_LOADED', period);
        },
        loadedCurrentYear: (context, year) => {
            context.commit('YEAR_LOADED', year);
        },
        loadedOpeningHours: (context, openingHours) => {
            context.commit('OPENINGHOURS_LOADED', openingHours);
        },
        loadedLabels: (context, labels) => {
            context.commit('LABELS_LOADED', labels);
        },
        loadedTreatmentLabels: (context, labels) => {
            context.commit('TREATMENTLABELS_LOADED', labels);
        },
        loadedVersion: (context, version) => {
            context.commit('VERSION_LOADED', version);
        },
        loadedTags: (context, tags) => {
            context.commit('TAGS_LOADED', tags);
        },
        toggleMini: (context, payload) => {
            context.commit('MINI_TOGGLE', payload);
        },
        updateFilters: (context, payload) => {
            context.commit('FILTERS_UPDATE', payload);
        },
        updateLessonTypes: (context, payload) => {
            context.commit('LESSONTYPES_UPDATE', payload);
        },
        selectedChanged: (context, payload) => {
            context.commit('SELECTED_CHANGE', payload);
        },
        selectedTopicsChanged: (context, payload) => {
            context.commit('SELECTED_TOPICS_CHANGE', payload);
        },
        openDialog: (context, options) => {
            context.commit('DIALOG_OPENED', options);
        },
        closeDialog: (context, options = null) => {
            context.commit('DIALOG_CLOSED', options);
        },
        checkboxReset: (context, payload) => {
            context.commit('RESET_CHECKBOXES', payload);
        },
        updateSetting: (context, payload) => {
            context.commit('UPDATE_SETTING', payload);
        },
        setApiOffline: (context, value) => {
            context.commit('SET_API_OFFLINE', value);
        },
        setIsLoading: (context, value) => {
            context.commit('SET_IS_LOADING', value);
        },
        setIsStoreInitialized: (context, value) => {
            context.commit('SET_IS_STORE_INITIALIZED', value);
        },
    },
});
